module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Cap-3-51c1d1e1dd93442df77ab0474183de2c.svg";